(function (angular) {
    'use strict';
    angular.module('SMART2').
	directive('documentLandingView', ['$timeout', '$http', '$compile', '$templateCache', '$translate', 'APPCONSTANTS', 'routeSvc', 'commonUtilities', documentLandingViewFunc]);
    function documentLandingViewFunc($timeout, $http, $compile, $templateCache, $translate, APPCONSTANTS, routeSvc, commonUtilities) {
        return {
            restrict: "E",
            scope: {
                documentData: "="
            },
            link: function (scope, element, attrs) {
                if (scope.documentData) {
                    scope.listDisplayConfig = scope.documentData.listDisplayConfig;
                    var documentList = [], isQuickActionApplied = false;
                    scope.actionMenuLinker = {
                        isTmplActive: true, docType: scope.documentData.docTypeId, onDelete: onDelete
                    };
                    var setQuickAction = function (docData) {
                        if (typeof scope.actionMenuLinker.evaluateOptions === "function") {
                            scope.actionMenuLinker.evaluateOptions(docData, scope.documentData.docTypeId);
                        }
                    }

                    scope.documentData.addDocuments = function (docData) {
                        var mapDocs = scope.documentData.Pagefor == "task" ? docData : commonUtilities.mapFields(docData, scope.documentData.docTypeId, scope.documentData.Pagefor), docCodes = [];
                        _.each(mapDocs, function (value, key) {
                            if (scope.documentData.Pagefor == "task") {
                                value.docUrl = APPCONSTANTS.userPreferences.URLs.AppURL + value.docUrl;
                                _.each(value.attributes, function (eachData) {
                                    eachData["IsVisible"] = true;
                                });
                                value.icon = commonUtilities.setValue(value.docType);
                            }
                            scope.documentData.documents.push(value);
                            documentList.push(docData[key]);
                            docCodes.push(value['DocumentCode']);
                        });
                        if (scope.documentData.listDisplayConfig.enableQuickActions) {
                            setQuickAction(mapDocs);
                        }
                    }
                 
                    scope.documentData.onListUpdate = function (docData) {
                        if (scope.documentData.listDisplayConfig.enableQuickActions) {
                            setQuickAction(docData);
                        }
                    }
                    if (scope.documentData.documents && scope.documentData.documents.length > 0) {
                        isQuickActionApplied = true;
                        $timeout(function () { setQuickAction(scope.documentData.documents); })
                    }
                    var redirect = function (index, url) {
                        routeSvc.goTo(url);
                    }
                    var mapClickFunc = {
                        "manage": redirect,
                        "search": redirect,
                        "task": redirect,
                        "template": showTemplateCall
                    };
                    scope.onTileClick = mapClickFunc[scope.documentData.Pagefor] ? mapClickFunc[scope.documentData.Pagefor] : callTileClick;

                    function callTileClick(index, url, item) {
                        scope.documentData.onTileClick({ item: item });
                    }
                    scope.setUrl = function (url) {
                        if ((!mapClickFunc[scope.documentData.Pagefor] || !scope.documentData.onTileClick) && !scope.documentData.disableTileClick) {
                            return url;
                        }
                        return undefined;
                    }

                    var showTemplateCall = function (index) {
                        var docTypeCode = parseInt(docTypeId);
                        if (documentList && templatePrvConfig[docTypeCode]) {
                            scope.showTemplatePreview = true;
                            _.each(documentList, function (d, i) {
                                angular.extend(d, scope.documentData.documents);
                            });
                            scope.slideObj = {
                                list: documentList,
                                index: index,
                                src: templatePrvConfig[docTypeCode]
                            };
                        }
                    };
                    scope.closeTemplatePreviewPopup = function () {
                        scope.showTemplatePreview = false;
                    }
                }
                scope.labels = {
                    resetButtonConfig: {
                        title: $translate.instant("filter_reset")
                    },
                    canceButtonConfig: {
                        title: $translate.instant("cancel")
                    },
                    loadMoreButtonConfig: {
                        title: $translate.instant("show_more")
                    },
                    viewLogButtonConfig: {
                        title: $translate.instant("filte_viewlog")
                    },
                    applyButtonConfig: {
                        title: $translate.instant("filter_apply"),
                    }
                }
                function onDelete(docCode) {
                    scope.documentData.documents = _.reject(scope.documentData.documents, function (item) { return item.DocumentCode == docCode });
                    if (scope.documentData.listDisplayConfig.deleteCallBack) {
                        scope.documentData.listDisplayConfig.deleteCallBack();
                    }
                }
            },
            templateUrl: 'workspace/workspaceDirectives/documentLandingView/documentLandingViewTemplate.html'
        };
    }
})(angular);